import React from "react";
import Lottie from "lottie-react";
import "./buttons.scss";
import loader8 from "../../../styles/images/l8.json";

type buttonProps = {
  type?: any;
  name?: any;
  className?: any;
  icon?: any;
  onClick?: any;
  htmlType?: any;
  disabled?: any;
  id?:any;
  onTouchStart?:any
};

type buttonState = {};
class WtButton extends React.Component<buttonProps, buttonState> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <button
          id={this.props.id}
          disabled={this.props.disabled}
          onClick={this.props.onClick}
          className={this.props.className}
          onTouchStart={this.props.onTouchStart}
        >
          {this.props.name !== "" ? (
            this.props.name
          ) : (
            <Lottie
              className="svgLoadinglistcenter"
              animationData={loader8}
              style={{ width: 30 }}
            />
          )}
        </button>
      </>
    );
  }
}

export { WtButton };
